import { IInquiry } from "src/@types/inquiries";
import { IClone } from "src/@types/clones";

export const getDealInitiator = (inquiry: IInquiry, clone: IClone) => (
  {
    title: inquiry?.title || clone?.company_name,
    cost: inquiry?.inquiry_cost || clone?.clone_cost,
    location: inquiry?.host.location || clone?.host.location,
    main_photo: clone?.main_photo,
  }
);